<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP"> </p>
<p class="Dedication-ded"><span epub:type="pagebreak" id="pg_5" title="5"><span class="ePub-I">For my boys, the other three parts that make me whole. I’d be a one-legged chair without you, my loves, and I think we can all agree that would be a pretty terrible chair.</span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?53e556d7